import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-trash",
  "use": "svg-trash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-trash\">\n  <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n  <path d=\"M6,10 L18,10 L18,18 C18,19.1 17.1,20 16,20 L8,20 C6.9,20 6,19.1 6,18 L6,10 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,5 C8,4.4 8.4,4 9,4 L15,4 C15.6,4 16,4.4 16,5 L16,7 Z M14,7 L14,6 L10,6 L10,7 L14,7 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol